import React from 'react';
import SubscriptionManager from '../components/SubscriptionManager';
import { requireLogin } from '../auth.js';

export default function TestSubscription() {
  // Ensure user is logged in
  React.useEffect(() => {
    requireLogin();
  }, []);

  return (
    <div className="test-subscription">
      <div className="container">
        <h1>Subscription Test Page</h1>
        <p>This page tests the complete subscription flow with Square integration.</p>
        
        <div className="test-info">
          <h3>Test Instructions:</h3>
          <ol>
            <li>Make sure you're logged in with Netlify Identity</li>
            <li>Click "Subscribe Now" to start the subscription process</li>
            <li>Use Square's test card: 4111 1111 1111 1111</li>
            <li>Complete the subscription flow</li>
            <li>Test the AI endpoint gating</li>
          </ol>
        </div>

        <SubscriptionManager />
      </div>
    </div>
  );
}

